import React, { memo } from 'react';

const SUCCESS = '#2ABB7F';
const WARNING = '#ffa500';
const ERROR = '#E2483D';

const StatusRendererComponent = ({ data }) => {
  if (data.hasError) {
    return (
      <span title={data.error}>
        Error
        <i className="fa fa-warning c-orange ml5" />
      </span>
    );
  }

  if (data.status.includes('spam')) {
    return <span style={{ color: ERROR }}>Spam Reports</span>;
  }

  switch (data.status) {
    case '': {
      return 'Sent';
    }

    case 'delivered': {
      return <span style={{ color: SUCCESS }}>Delivered</span>;
    }

    case 'open': {
      return <span style={{ color: SUCCESS }}>Opened</span>;
    }

    case 'click': {
      return <span style={{ color: SUCCESS }}>Clicked</span>;
    }

    case 'processed': {
      return <span style={{ color: WARNING }}>Processed</span>;
    }

    case 'dropped': {
      return <span style={{ color: ERROR }}>Dropped</span>;
    }

    case 'deferred': {
      return <span style={{ color: WARNING }}>Deferred</span>;
    }

    case 'bounce': {
      return <span style={{ color: ERROR }}>Bounce</span>;
    }

    default:
      return data.status;
  }
};

export const StatusRenderer = memo(StatusRendererComponent);
